import { useCallback, useRef } from 'react';

export function useDebounceFunction<T extends unknown[]>(
  func: (...args: T) => void,
  delay: number,
): (...args: T) => void {
  const ref = useRef<NodeJS.Timeout | null>(null);

  return useCallback(
    (...args: T) => {
      if (ref.current) clearTimeout(ref.current);
      ref.current = setTimeout(() => func(...args), delay);
    },
    [delay, func],
  );
}
